import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';

interface ConfirmModalProps {
  text: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmModal = ({ text, onCancel, onConfirm }: ConfirmModalProps) => {
  return (
    <>
      <LS.ModalBg>
        <CS.ModalBoxType2>
          <p>{text}</p>
          <div className="btn-box">
            <CS.Btn2Type2 type="button" onClick={onCancel}>
              취소
            </CS.Btn2Type2>
            <CS.Btn2Type1 type="button" onClick={onConfirm}>
              확인
            </CS.Btn2Type1>
          </div>
        </CS.ModalBoxType2>
      </LS.ModalBg>
    </>
  );
};

export default ConfirmModal;
